// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vX yc","ribbon":"vY ym","title":"vZ ye","year":"v0 yf","genres":"v1 yl","duration":"v2","buttonWrapper":"v3 yh","button":"v4 yi","price":"v5","upperParts":"v6"};